import React from 'react';

const ZebralearnLogoIcon = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={12}
      viewBox='0 0 12 12'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_78_276)'>
        <path
          d='M0.0200195 0.0419931L1.41743 1.30839L3.25393 1.31579L4.19729 0.0166016L0.0200195 0.0419931Z'
          fill='#979797'
        />
        <path
          d='M0.0183105 0.0410156V5.56787L1.41572 1.30741L0.0183105 0.0410156Z'
          fill='#EFEFEF'
        />
        <path
          d='M1.41596 1.30811L3.25246 1.31551L0.0185547 5.56856L1.41596 1.30811Z'
          fill='white'
        />
        <path
          d='M5.41919 1.30872L6.53775 0.0571289H9.77913L7.05057 1.31612L5.41919 1.30872Z'
          fill='#979797'
        />
        <path
          d='M5.41896 1.30811L7.05033 1.31551L1.71711 7.7258L0.0483398 7.74587L5.41896 1.30811Z'
          fill='#B2B2B2'
        />
        <path
          d='M0.0499004 7.74566L1.71867 7.72559L0.0317383 11.9046L0.0499004 7.74566Z'
          fill='#EFEFEF'
        />
        <path
          d='M1.71867 7.72639L7.05189 1.31612L9.78045 0.0571289L0.0317383 11.9053L1.71867 7.72639Z'
          fill='white'
        />
        <path
          d='M2.23657 11.8785L5.03673 10.4874L10.4137 4.11307L12.0121 0.0166016L2.23657 11.8785Z'
          fill='#979797'
        />
        <path
          d='M5.03697 10.4868L6.65873 10.5905L5.5156 11.8728L2.23682 11.8781L5.03697 10.4868Z'
          fill='#EFEFEF'
        />
        <path
          d='M12.0112 0.0166016L10.4128 4.11306H12.0357L12.0112 0.0166016Z'
          fill='#EFEFEF'
        />
        <path
          d='M10.4127 4.11328H12.0355L6.65741 10.5913L5.03564 10.4876L10.4127 4.11328Z'
          fill='white'
        />
        <path
          d='M8.83765 10.556H10.5973L11.9915 6.37598L8.83765 10.556Z'
          fill='#979797'
        />
        <path
          d='M8.8373 10.5557H10.5968L12.0167 11.9035L7.82983 11.8982L8.8373 10.5557Z'
          fill='#EFEFEF'
        />
        <path
          d='M11.9912 6.37646L12.0168 11.9044L10.5969 10.5564L11.9912 6.37646Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_78_276'>
          <rect width={12} height='11.9678' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ZebralearnLogoIcon;
